import useSWR from "swr";

import { type WorkflowDetails } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/workflows";

export function useWorkflow(id: string | number | undefined) {
  return useSWR<WorkflowDetails, Error>(
    id ? `${url}/${id}` : null,
    simpleFetcher,
  );
}
